export default [
    {
        path: '/admin-vip/informacion',
        meta: { nombre: 'información para los usuario' },
        component: () => import(/* webpackChunkName: "informacion" */ '../../pages/informacion/admin-vip').then(m => m.default || m),
        children: [
            {
                path: 'preguntas-frecuentes',
                meta: { nombre: 'información para los usuarios' },
                name: 'admin-vip.info.preguntas',
                component: () => import(/* webpackChunkName: "informacion" */ '../../pages/informacion/preguntas').then(m => m.default || m),
            },
            {
                path: 'terminos',
                meta: { nombre: 'información para los usuarios' },
                name: 'admin-vip.info.terminos',
                component: () => import(/* webpackChunkName: "informacion" */ '../../pages/informacion/terminos').then(m => m.default || m),
            },
            {
                path: 'politica',
                meta: { nombre: 'información para los usuarios' },
                name: 'admin-vip.info.politica',
                component: () => import(/* webpackChunkName: "informacion" */ '../../pages/informacion/politica').then(m => m.default || m),
            }
        ]
    }
]
